<h3 mat-dialog-title>Enable Text Message Authentication</h3>

<mat-dialog-content>
    <app-sms-auth-setup-step (completed)="onCompleted()"
                             (cancelled)="onCancelled()"></app-sms-auth-setup-step>
</mat-dialog-content>
